import { useQuery } from "@tanstack/react-query";
import { getConversationDetails, getConversations } from "../../api/calls/conversationsApi";

export const useGetConversations = ({
    limit = 50,
    offset = 0,

}:{
    limit?: number;
    offset?: number;
}) => {
    return useQuery({
        queryKey: ["conversations", { limit, offset }],
        queryFn: async () => {
            const response = await getConversations();
            return response;
        },
        staleTime: 1000 * 60, // 60 seconds
    });
};

export const useGetConversationDetails = (callId?: number) => {
    const enabled = (typeof callId === 'number' && Number.isFinite(callId)) 
    return useQuery({
        queryKey: ["conversation-details", callId],
        queryFn: async () => {
            const response = await getConversationDetails(Number(callId));
            return response;
        },
        staleTime: 1000 * 60, // 60 seconds
        enabled
    });
};
